import React from "react";
import BaseFormItem from "../BaseFormItem";
import entityFieldMetaStore from "data/meta/entityFieldMetaStore";
import Control from "lib/common/descriptorcontrols/StringField/text";

export class StringFieldtext extends BaseFormItem {

    constructor(props) {
        super(props);
        const { activeRecord, descriptor } = props;
        // these can't change
        this.info = entityFieldMetaStore.getInfo(
            activeRecord.entityKey,
            descriptor.key,
        );
        this.maxLengthScript = this.info ? this.info.scripts.maxLength : undefined;
        this.__enablePureOverValueAndEnabledHandling();
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (this.maxLengthScript) return true;
        return super.shouldComponentUpdate(nextProps, nextState, nextContext);
    }

    render() {
        const { value, enabled } = this.state;
        const mls = this.maxLengthScript;
        let maxLength = mls
            ? mls(this.props.activeRecord)
            : undefined;
        if (maxLength > 15) {
            maxLength = undefined;
        }
        return <Control
            {...this.getPlumbingProps()}
            maxLength={maxLength}
            value={value}
            enabled={enabled}
        />;
    }
}

export default StringFieldtext;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/StringField/text.js